exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".query-link[data-v-4c50e90c]{color:#4d7cfe;margin-left:5px;cursor:pointer}.query-link[data-v-4c50e90c]:first-child{margin-left:0}", ""]);

// exports
